import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Wraps workspace-scoped pages. Super admin gets redirected to their panel.
export default function WorkspaceOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "super_admin") return <Navigate to="/superadmin/users" replace/>;
  if (!(user.module_access || ["keuangan"]).includes("keuangan")) return <Navigate to="/hpp" replace/>;
  return children;
}
